import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INavigation } from '@sv/interfaces';
import { customApp } from 'src/app/_configuration/configuration';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private currentNavigation: INavigation;

  constructor(private http: HttpClient) {}

  getCurrentNavigation() {
    return this.currentNavigation;
  }

  async getNavigationById(id: string): Promise<INavigation> {
    const result = await this.http
      .get<{ status: string; data: INavigation; error? }>(customApp.url + `/app/event/navigation/findById?id=${id}`)
      .toPromise();

    if (result.status === 'error') {
      throw result.error;
    } else {
      return result.data;
    }
  }

  async getCompleteNavigationById(id: string): Promise<INavigation> {
    if (this.currentNavigation) {
      return this.currentNavigation;
    }
    const result = await this.http
      .get<{ status: string; data: INavigation; error? }>(
        customApp.url + `/app/event/navigation/findCompleteById?id=${id}&eventId=${customApp.eventId}`
      )
      .toPromise();

    if (result.status === 'error') {
      throw result.error;
    } else {
      this.currentNavigation = result.data;
      return result.data;
    }
  }
}
